import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import dataPegawai from '../views/profil/datapegawai.vue'
import profilDinas from '../views/profil/profilDinas.vue'
import tujuan from '../views/profil/tujuan.vue'
import strategi from '../views/profil/strategi.vue'
import kebijakan from '../views/profil/kebijakan.vue'
import program from '../views/profil/program.vue'
import strukturOrganisasi from '../views/profil/strukturOrganisasi.vue'
import regulasi from '../views/unduhan/regulasi.vue'
import dataDokumen from '../views/unduhan/dataDokumen.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/dataPegawai',
    name: 'dataPegawai',
    component: dataPegawai
  },
  {
    path: '/profilDinas',
    name: 'profilDinas',
    component: profilDinas
  },
  {
    path: '/tujuan',
    name: 'tujuan',
    component: tujuan
  },
  {
    path: '/strategi',
    name: 'strategi',
    component: strategi
  },
  {
    path: '/kebijakan',
    name: 'kebijakan',
    component: kebijakan
  },
  {
    path: '/program',
    name: 'program',
    component: program
  },
  {
    path: '/strukturOrganisasi',
    name: 'strukturOrganisasi',
    component: strukturOrganisasi
  },
  {
    path: '/regulasi',
    name: 'regulasi',
    component: regulasi
  },
  {
    path: '/dataDokumen',
    name: 'dataDokumen',
    component: dataDokumen
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
